import { Carousel } from 'react-bootstrap'
import { useState } from 'react'
import { MDBCarousel, MDBCarouselItem } from 'mdb-react-ui-kit'
import { IMAGE_DIR } from '@/shared/constants/linksApi'

export const CarouselImages = ({ imagesProduct, favouriteImage, children }) => {
    return (
        <MDBCarousel
            showControls={true}
            className={'CarouselImages'}
            interval={50000}
            fade={true}
            showIndicators={true}
        >
            {children}
            <MDBCarouselItem itemId={1}>
                <img src={IMAGE_DIR + favouriteImage} alt="item-product" />
            </MDBCarouselItem>
            {imagesProduct.map(({ image }, index) => {
                return (
                    <MDBCarouselItem itemId={index + 2}>
                        <img src={IMAGE_DIR + image} alt="item-product" />
                    </MDBCarouselItem>
                )
            })}
        </MDBCarousel>
    )
    return (
        <MDBCarousel
            showIndicators
            showControls
            touch
            className={'CarouselImages'}
        >
            <MDBCarouselItem itemId={1}>
                <img src={IMAGE_DIR + favouriteImage} alt="item-product" />
            </MDBCarouselItem>
            {imagesProduct.map((item, index) => (
                <MDBCarouselItem itemId={index + 1} key={item.product_image_id}>
                    <img src={IMAGE_DIR + item.image} alt="item-product" />
                </MDBCarouselItem>
            ))}
        </MDBCarousel>
    )
}
